import {poll} from '@yourcoach/async-utils';

import type {Expand} from '../types';

import {not} from '../../utils/conditionalUtils';
import {envManager} from '../../utils/env';
import {extendExpand} from '../utils/expand';

export const certificateExpandCommon: Expand = {
  certificate: ['file_id'],
};

poll(
  () => envManager.isReady,
  () => {
    if (not(envManager.get('isB2b'))) {
      extendExpand(
        certificateExpandCommon,
        ['institution_id', 'qualification_id'],
        true,
      );
    }
  },
);
